import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import Map, { Marker } from "react-map-gl";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import { Mobile, Landscape } from "../Response";
import "mapbox-gl/dist/mapbox-gl.css";
const My_Map = () => {
  const back = useSelector((state) => state.switch.back);
  const MapBoxToken = process.env.REACT_APP_MAPBOX;
  let zoom = 11.7;
  return (
    <Container back={back}>
      <Lable back={back}>
        <h2>Find Me Here</h2>
      </Lable>
      <Wraper ack={back}>
        <Map
          // onDblClick={(e) => console.log(e.lngLat)}
          initialViewState={{
            latitude: 35.576959213122336,
            longitude: 45.359759820343726,
            zoom,
          }}
          style={{ width: "100%", height: "100%" }}
          mapStyle={
            back === "moon"
              ? `mapbox://styles/mapbox/dark-v10`
              : `mapbox://styles/mapbox/streets-v11`
            // `mapbox://styles/mapbox/streets-v11`
          }
          mapboxAccessToken={MapBoxToken}
        >
          <Marker longitude={45.359759820343726} latitude={35.576959213122336}>
            <Icon
              style={{
                fontSize: `${zoom * 4}`,
              }}
            />
          </Marker>
        </Map>

        <LeftGra className={back === "sun" ? `white` : `black`} />
        <RightGra className={back === "sun" ? `white` : `black`} />
      </Wraper>
    </Container>
  );
};
export default My_Map;
const Container = styled.div`
  overflow: hidden;
  width: 100%;
  height: 80vh;
  background: ${(props) => (props.back === "sun" ? " #f9fdff" : "#0d1116")};
  margin: 100px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: relative;
  ${Mobile({ height: "50vh", margin: "50px 0px 0px 0px" })}
  ${Landscape({ margin: "100px 0px", height: "85vh" })}
`;
const Lable = styled.div`
  z-index: 6;

  margin-top: 0px;
  width: 40%;
  height: 9%;
  border-radius: 20px;
  backdrop-filter: blur(5px);

  background: ${(props) =>
    props.back === "sun" ? "rgba(246, 253, 254, 0.5)" : "rgb(22, 28, 35,0.3)"};
  // background: red;

  display: flex;
  justify-content: center;
  align-items: center;
  ${Mobile({
    zindex: 3,
    width: "70%",
    height: "12%",
    marginTop: "50px",
    borderRadius: "10px",
    border: "1px solid rgba(143, 166, 168, 0.1)",
  })}

  ${Landscape({ height: "14%", margin: "30px 0px", borderRadius: "15px" })}
  h2 {
    color: ${(props) =>
      props.back === "sun" ? "  #686868" : "rgba(228, 236, 240, 0.8)"};
    letter-spacing: 3px;
    ${Mobile({ letterSpacing: "1px", fontSize: 16 })}
  }
`;
const Wraper = styled.div`
  z-index: 1;
  border-radius: 50px;
  overflow: hidden;
  position: relative;
  // background: gray;
  width: 56%;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: ${(props) => props.back === "sun" && "5px solid white"};
  box-shadow: ${(props) =>
    props.back === "sun" && " 0px 3px 4px 0px rgba(143, 166, 168, 0.2)"};
  ${Mobile({
    borderRadius: "20px",
    width: "87%",
    height: "50%",
  })}
  ${Landscape({
    height: "85%",
    marginTop: 10,
    borderRadius: "20px",
    width: "58%",
  })}
`;
const LeftGra = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;

  width: 25%;
  height: 100%;
  &.white {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 0%,

      rgba(9, 9, 121, 0) 100%
    );
  }
  &.black {
    background: linear-gradient(
      90deg,
      rgb(13, 17, 22) 0%,
      rgb(13, 17, 22, 0.9) 10%,
      rgb(13, 17, 22, 0.75) 20%,
      rgba(26, 32, 39, 0.6) 50%,
      rgba(26, 32, 39, 0.2) 80%,

      rgba(9, 9, 121, 0) 100%
    );
  }
`;
const RightGra = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;

  width: 25%;
  height: 100%;

  &.white {
    background: linear-gradient(
      90deg,
      rgba(9, 9, 121, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  &.black {
    background: linear-gradient(
      90deg,
      rgba(9, 9, 121, 0) 0%,
      rgb(13, 17, 22) 100%,
      rgb(13, 17, 22, 0.9) 90%,
      rgb(13, 17, 22, 0.75) 80%,
      rgba(26, 32, 39, 0.6) 50%,
      rgba(26, 32, 39, 0.2) 20%
    );
  }
`;

const Icon = styled(PersonPinIcon)`
  color: #04cd00;

  // ${Mobile({ fontSize: "23px" })}
`;
